import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import UserMenu from './UserMenu';
import Sidebar from './Sidebar';
import axios from 'axios';
import AdvanceMonitor from './ui/AdvanceMonitor';
import Tools from './Tools';
import './css/Home.css';

const WaitingCalls = (props) => {

    const [connectedCampaigns, setConnectedCampaigns] = useState([]); 
    const [campaign, setCampaign] = useState(null); 
    const [error, setError] = useState(null); 
    const [disconnectionExecuted, setDisconnectionExecuted] = useState(false); 

    const { campaignId } = useParams(); 
    const history = useHistory();


    const executeUserAMIAction = (action)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/userAMIAction`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: action
        };
        axios(options).then(response => {
            //console.log('🐞DEBUG executeUserAMIAction response:', response);
        });
    }

    const unassignCampaign = (campaign) => {
        const connectedCampaignsList = [...connectedCampaigns];

        let foundIndex=connectedCampaignsList.findIndex((cmp)=> cmp._id === campaign._id);
        if(foundIndex!==-1){
            connectedCampaignsList.splice(foundIndex, 1); 
            setConnectedCampaigns(connectedCampaignsList);
            
            //save selection on session
            sessionStorage.setItem("connectedCampaigns", JSON.stringify(connectedCampaignsList));
        }

    }

    const disconnectFromCurrentCampaign=()=>{
        if (connectedCampaigns?.length>0){
            let campaign=connectedCampaigns[0];
            executeUserAMIAction({ action: 'QUEUEREMOVE', queue: campaign.context }); 
            unassignCampaign(campaign);
        }
        history.push("/campaigns"); 
    }


    useEffect(() => {
        setConnectedCampaigns(JSON.parse(sessionStorage.getItem("connectedCampaigns")));

        //get campaign
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/campaign`, {
            params: { campaignId: campaignId }
        })
        .then(function (response) {
            setCampaign(response.data);
        })
        .catch ((error) => {
            if (error?.response?.data?.error === 'Unauthorized') {
                 if (!disconnectionExecuted) {
                    Tools.forceLogout(history);
                    setDisconnectionExecuted(true);
                }
            }
            setError(error.message);
        });

    }, []);

    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} current="10" softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            <div className="main">
                <div className="headerWrapper">
                    
                    {campaign ? (
                    <div className="titleWrapper">    
                        <h1 className='companyColor' style={{textDecorationColor:campaign.company_info.color}}>{campaign.company_info.name}</h1>
                        <span className="upper">{campaign.name}</span>
                    </div>
                    ):null}

                    
                    <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues}/>
                </div>
                <div className='waitingCallsBanner'>
                    {/* <div className="lds-ripple"><div></div><div></div></div> */}
                    <div className="hourglass"></div>
                    <div>
                        <AdvanceMonitor campaignId={campaignId} width="100%"/>
                        <h1>En espera de llamados</h1>
                        <p><a onClick={disconnectFromCurrentCampaign}>Desconectar</a> de campaña actual.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WaitingCalls;